<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
    <path
      d="M12.1406 14.1089L3.28121 14.1089"
      stroke="#2B2B2B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M17.7187 14.1089L15.4218 14.1089"
      stroke="#2B2B2B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M13.7812 15.7495C14.6873 15.7495 15.4218 15.015 15.4218 14.1089C15.4218 13.2028 14.6873 12.4683 13.7812 12.4683C12.8751 12.4683 12.1406 13.2028 12.1406 14.1089C12.1406 15.015 12.8751 15.7495 13.7812 15.7495Z"
      stroke="#2B2B2B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M6.89058 6.89021L3.28121 6.89014"
      stroke="#2B2B2B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M17.7187 6.89014L10.1718 6.89021"
      stroke="#2B2B2B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M8.53121 8.53076C9.4373 8.53076 10.1718 7.79623 10.1718 6.89014C10.1718 5.98404 9.4373 5.24951 8.53121 5.24951C7.62512 5.24951 6.89058 5.98404 6.89058 6.89014C6.89058 7.79623 7.62512 8.53076 8.53121 8.53076Z"
      stroke="#2B2B2B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </svg>
</template>
